import { css } from '@emotion/core';

export default css`
  > div > button {
    border-radius: 0;
    margin-bottom: 0;
  }
`;
